// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"343":"73b1d9720e386623","4804":"c2e02cbcae6293ac","7998":"dfe787fff6d1d457"}[chunkId] + ".css";
};